import {convertToUrlParams} from 'utils'
import baseApi from './baseApi'

const paymentsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPayments: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `payments${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
        }),
        getPayment: build.query({
            query: (id) => ({
                url: `payments/${id}`,
                method: 'GET',
            }),
            transformResponse: (res) => res,
        }),
        updatePaymentStatus: build.mutation({
            query: ({id, data}) => ({
                url: `payments/${id}`,
                method: 'PUT',
                body: data,
            }),
            transformResponse: (res) => res,
        }),
        refreshPaymentToken: build.mutation({
            query: (paymentId) => ({
                url: `payments/${paymentId}/refresh-token`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
        }),
        getPaymentIframe: build.query({
            query: (token) => ({
                url: `payments/iframe/${token}`,
                method: 'GET',
            }),
            transformResponse: (res) => res,
        }),
        getPaymentById: build.query({
            query: (paymentId) => ({
                url: `payments/${paymentId}`,
                method: 'GET',
            }),
            transformResponse: (res) => res,
        }),
    }),
})

export const {
    useGetPaymentsQuery,
    useGetPaymentQuery,
    useUpdatePaymentStatusMutation,
    useRefreshPaymentTokenMutation,
    useGetPaymentIframeQuery,
    useGetPaymentByIdQuery,
} = paymentsApi

export default paymentsApi
